export const SET_RECOVER_LOGIN_STATUS = 'SET_RECOVER_LOGIN_STATUS';
export const SET_CHECK_RECOVER_LOGIN_RESULT_FROM_INBOUND = 'SET_CHECK_RECOVER_LOGIN_RESULT_FROM_INBOUND';
export const SET_IS_RESET_PASSWORD_PENDING = 'SET_IS_RESET_PASSWORD_PENDING';
export const SET_RESET_PASSWORD_ERROR = 'SET_RESET_PASSWORD_ERROR';
export function setRecoverLoginStatus(status) {
    return {
        type: SET_RECOVER_LOGIN_STATUS,
        payload: status
    };
}
export function setCheckRecoverLoginResultFromInbound(inbound) {
    return {
        type: SET_CHECK_RECOVER_LOGIN_RESULT_FROM_INBOUND,
        payload: inbound
    };
}
export function setIsResetPasswordPending(isPending) {
    return {
        type: SET_IS_RESET_PASSWORD_PENDING,
        payload: isPending
    };
}
export function setResetPasswordError(error) {
    return {
        type: SET_RESET_PASSWORD_ERROR,
        payload: error
    };
}
